import React, { FC } from 'react';
import MuiSvgIcon, { SvgIconProps as MuiSvgIconProps } from '@material-ui/core/SvgIcon';
import { Uds } from '../../types';

export type SvgIconProps = Uds<
  Omit<MuiSvgIconProps, 'color'> & {
    color?: MuiSvgIconProps['htmlColor'];
  }
>;

export const SvgIcon: FC<React.PropsWithChildren<SvgIconProps>> = ({ dataTest, color, ...props }) => (
  <MuiSvgIcon htmlColor={color} data-test={dataTest} {...props} />
);
